export default {
  'moduleTitle.address': 'Adresas',
  'moduleTitle.address_details': 'Adreso duomenys',
  'moduleTitle.activity_details': 'Veiklos detalės',
  'moduleTitle.add_log': 'Pridėti įrašą',
  'moduleTitle.award_level': 'Apdovanojimo lygis',
  'moduleTitle.adventurous_journey': 'Žygis',
  'moduleTitle.already_assessed': 'Įvertintas!',
  'moduleTitle.approved': 'Patvritintas!',
  'moduleTitle.assessor_details': 'Vertintojo duomenys',
  'moduleTitle.authorising_contact_license_holder': 'Licencijos turėtojas',
  'moduleTitle.category_journey_details': '{category} žygio detalės',
  'moduleTitle.complete_report': 'Pabaigti ataskaitą',
  'moduleTitle.completed_progress': 'Pabaigta {finished} / {total}',
  'moduleTitle.congratulation': 'Sveikiname!',
  'moduleTitle.confirming_email_address': 'Tvirtinamas el. pašto adresas',
  'moduleTitle.contact_details': 'Kontaktai',
  'moduleTitle.edit_log': 'Redaguoti įrašą',
  'moduleTitle.event_journey': '{event} žygis',
  'moduleTitle.forgotten_password': 'Pamiršau slaptažodį',
  'moduleTitle.great_you_are_almost_there': 'Puiku, Jūs beveik su mumis. Paskutinis žingsnis - apmokėjimas už programą.',
  'moduleTitle.home_address': 'Namų adresas',
  'moduleTitle.journey_overview': 'Žygio apžvalga',
  'moduleTitle.log_detail': 'Prisijungimo duomenys',
  'moduleTitle.login': 'Prisijungti',
  'moduleTitle.new_activity': 'Nauja veikla',
  'moduleTitle.new_event_journey': 'Naujas {event} žygis',
  'moduleTitle.new_residential_project': 'Naujas rezidavimo projektas',
  'moduleTitle.notRegistred': 'Dar neužsiregistravote?',
  'moduleTitle.nominated_award_leader_contact_details': 'Paskirto DofE vadovo kontaktai',
  'moduleTitle.nominated_award_leader': 'Paskirtas DofE vadovas',
  'moduleTitle.organisation_address': 'Organizacijos adresas',
  'moduleTitle.organisation_details': 'Organizacijos duomenys',
  'moduleTitle.online_record_book_account': 'Elektroninės pasiekimų knygelės duomenys',
  'moduleTitle.page_not_found': '404- Puslapis nerastas',
  'moduleTitle.personal_details': 'Asmeniniai duomenys',
  'moduleTitle.preparation_and_training': 'Pasiruošimas ir žygio planavimas',
  'moduleTitle.profile_guardian_consent': 'tevų/globėjų sutikimas',
  'moduleTitle.profile_questions': 'Asmeniniai klausimai',
  'moduleTitle.registration_for_level': 'Registracija į naują lygį',
  'moduleTitle.residential_project': 'Rezidavimo projektas',
  'moduleTitle.residential_project_details': 'Rezidavimo projekto duomenys',
  'moduleTitle.reset_password': 'Atnaujinti slaptažodį',
  'moduleTitle.welcome_to_the_orb': 'Sveikiname prisijungus prie e-DofE platformos',
  'moduleTitle.we_have_sent_you_an_email': 'Išsiuntėme Jus laišką su prisijungimo duomenimis',
  'moduleTitle.your_registration_is_complete': 'Registracija baigta',
  'formTitle.activity_details': 'Veiklos detalės',
  'formTitle.assessor_details': 'Vertintojo duomenys',
  'formTitle.supervisors_details': 'Prižiūrėtojo duomenus',
  'formTitle.preparation_and_training_activities': 'Pasiruošimo ir žygio planavimo veiklos',
  'formTitle.added_preparation_activities': 'Pridėtos pasiruošimo ir žygio planavimo veiklos',
  'label.add_picture': 'Pridėti paveikslėlį',
  'label.address_first_line': 'Adresas 1',
  'label.address_second_line': 'Adresas 2 (neprivaloma)',
  'label.are_you_already_running_award': 'Ar jau  ykdote Apdovanojimų programą?',
  'label.are_you_the_main_award_leader': 'Ar Jūs pagrindinis DofE vadovas ar koordinatorius savo organizacijoje?',
  'label.award_participant': 'Apdovanojimų programos dalyvis',
  'label.award_leader': 'DofE vadovas',
  'label.birthdate': 'Gimimo data',
  'label.category': 'Kategorija',
  'label.change_locale': 'Keisti vietą',
  'label.choose_project': 'Pasirinkti projektą',
  'label.city': 'Miestas',
  'label.choose_as_major_activity': 'Pasirinkite pagrindinę veiklą',
  'label.date': 'Data',
  'label.date_of_birth': 'Gimimo data',
  'label.description_of_progress': 'Apibūdinkite savo progresą',
  'label.duration': 'Trukmė (minutėmis)',
  'label.email': 'El. paštas',
  'label.email_address': 'El. pašto adresas',
  'label.email_again': 'Pakartokite el. pašto adresą',
  'label.employment_status': 'Darbuotojo statusas',
  'label.end_date': 'Pabaigos data',
  'label.enter_his_email': 'Įveskite el. pašto adresą',
  'label.entered_transaction_id': 'Jūsų ID',
  'label.first_name': 'Pirmas vardas',
  'label.gender': 'Lytis',
  'label.goal': 'Tikslas',
  'label.journey_activity': 'Žygio veikla',
  'label.journey_objective': 'Žygio tikslas',
  'label.journey_observations': 'Žygio stebėjimas',
  'label.journey_type': 'Žygio tipas',
  'label.last_name': 'Pavardė',
  'label.level': 'Lygis',
  'label.location': 'Vieta',
  'label.logout': 'Atsijungti',
  'label.major': 'Pagrindinė veikla',
  'label.middle_name': 'Vidurinis vardas',
  'label.mode_of_transport': 'Trasnporto priemonė',
  'label.my_award_leader': 'DofE vadovas',
  'label.name': 'Vardas',
  'label.nationality': 'Tautybė',
  'label.no': 'Ne',
  'label.no_results': 'Nėra rezultatų',
  'label.note': 'Pastaba',
  'label.note_for_assessor': 'Pastaba vertintojui',
  'label.note_for_leader': 'Pastaba DofE vadovui',
  'label.optional': 'neprivaloma',
  'label.organisation_name': 'Organizacijos pavadinimas',
  'label.organisation_type': 'Organizacijos tipas',
  'label.others': 'Kita',
  'label.password': 'Slaptažodis',
  'label.password_again': 'Pakartoti slaptažodį',
  'label.project_location': 'Projekto vieta',
  'label.pay_online': 'Sumokėti internetu',
  'label.pay_award_leader_or_unit': 'Sumokėti DofE vadovui arba organizacijai',
  'label.payment_not_required': 'Mokėjimas nereikalingas',
  'label.payment_type': 'Mokėjimo tipas:',
  'label.phone': 'Telefonas',
  'label.phone_number': 'Telefono numeris',
  'label.phone_type': 'Telefono tipas',
  'label.profile': 'Profilis',
  'label.reset_password': 'Atnaujinti slaptažodį',
  'label.region': 'Regionas',
  'label.relationship': 'Santykiai',
  'label.role_in_organisation': 'Paskirtis organizacijoje',
  'label.select_country': 'Pasirinkti šalį',
  'label.select_your_au': 'Pasirinkti organizaciją',
  'label.start_typing': 'Pradėti pildyti',
  'label.start_date': 'Pradžios data',
  'label.select': 'Pasirinkti',
  'label.select_async': 'Pradėti pildyti',
  'label.select_your_operating_authority': 'Select your Operating Authority',
  'label.specify_category': 'Patikslinkite kategoriją',
  'label.subcategory': 'Subkategorija',
  'label.title': 'Pavadinimas',
  'label.username': 'Vartotojo vardas',
  'label.what_is_your_role': 'Kokia Jūsų paskirtis organizacijoje?',
  'label.where_have_you_completed': 'Kurioje organizacijoje gavote Apdovanojimą?',
  'label.yes': 'Taip',
  'label.your_changes_havent_been_saved': 'Pakeitimai nebuvo išsaugoti. Duomenys bus prarasti.',
  'label.zip': 'Pašto kodas',
  'label.adventurous_journey': 'Žygis',
  'label.after_your_journey_describe': 'Apibūdinkite savo žygį keliais sakiniais',
  'label.because_your_age_is_under_18': 'Kadangi esate jaunesnis nei 18 metų, reikalingas tėvų/globėjų sutikimas.',
  'label.before_you_head_to_journey': 'Prieš pradedant bandomąjį žygį, turite pabaigti pasiruošimą ir žygio planavimą.',
  'label.before_entering_new_level': 'Prieš pradedant naują lygį, patvirtiknkite, kad Jūsų asmeniniai duomenys yra teisingi.',
  'label.bring_required_amount_to_your_award_leader': 'Bring required amount to your Award Leader or Award Coordinator in your Unit.',
  'label.do_you_have_any_other_level': 'Ar jau esate pasiekęs bent vieną Apdovanojimo lygį?',
  'label.do_you_know_who_is_your_award_leader': 'Ar žinote, kas yra Jūsų DofE vadovas?',
  'label.going_on_an_expedition': 'Keliaudami į žygį gaunate galimybę dirbti kaip komanda bei dirbti savarankiškai.',
  'label.going_on_residential_gives_chance': 'Vykdant rezidavimo projektą turėsite galimybę išmokti, kaip dirbti su kitais žmonėmis iš įvairių visuomenės ir socialinių sluoksnių.',
  'label.i_confirm_that_i_meet': 'Sutinku su NAC reikalavimais.',
  'label.i_agree_to_volunteer_code': 'Sutinku laikytis savanoriškos veiklos sutarties. Dėl daugiau informacijos spauskite čia.',
  'label.i_have_read_the_terms_and_conditions': 'Perskaičiau terminus ir sąlygas ir sutinku su jais.',
  'label.i_will_bring_the_consent_to_my_award_leader_later': 'Pristatysiu sutikimą DofE vadovui vėliau',
  'label.if_you_are_from_orphanage': 'Jei esate iš vaikų, už programą mokėti nereikia.',
  'label.here_you_can_add_activity': 'Ar darėte kažką papildomai pasiruošimui ir žygio planavimui?',
  'label.how_do_you_want_to_apply': 'Kaip norite prisiregistruoti',
  'label.my_parent_consent_has_been_already_given': 'Mano tėvai/globėjai davė sutikimą DofE vadovui.',
  'label.my_parent_will_confirm_consent_by_email': 'Mano tėvai/globėjai atsiųs sutikimą el. paštu',
  'label.major_activity_means_that_you_have_to_spent': 'Pagrindinė veikla reiškia, kad jai turite skirti dvigubai daugiau laiko nei kitoms veikloms.',
  'label.not_sure_about_your_auth': 'nesate tikras dėl Apdovanojimus vykdančios organizacijos kompetencijų? Susisiekite su mumis.',
  'label.page_not_found': '404-Puslapis nerastas',
  'label.please_fill_in_the_following': 'Užpildykite žemiau esančias detales',
  'label.register_a_new_account_as': 'Užregistruoti naują dalyvį',
  'label.residential_project': 'Rezidavimo projektas',
  'label.select_your_award_unit': 'Pasirinkite Apdovanojimus vykdančią organizaciją',
  'label.the_expedition_can_be_faraway': 'Žygis gali vykti kokiu tik norite atstumu nuo namų, tai priklauso nuo Jūsų.',
  'label.to_log_your_process_on_orb': 'Norint registruoti veiklas e-DofE platformoje, turite turėti asmeninį profilį.<br /> Įveskite savo duomenis čia.',
  'label.waiting_for_assessment': 'Laukiama įvertinimo.',
  'label.waiting_for_sign_off': 'Laukiama DofE vadovo patvirtinimo',
  'label.we_have_sent_you_an_email': 'Išsiuntėme Jums laišką su aktyvavimo nuoroda.',
  'label.what_level_of_the_award': 'Kokio lygio sieksite?',
  'label.you_are_now_registering_as_participant': 'Jūs registruojatės kaip DofE dalyvis.',
  'label.you_are_now_registering_as_award_unit': 'Registruojatės kaip Apdovanojimus vykdanti organizacija.',
  'label.you_can_use_my_photos_for_promotional_purposes': 'Kaip DofE dalyvis, duodu sutikimą DofE biurui naudoti mano nuotraukas.',
  'label.you_can_send_activity_for_approval': 'Galite nusiųsti savo veiklą vertintojui įvertinti.',
  'label.you_can_send_activity_for_leader': 'Galite nusiųsti savo veiklą DofE vadovui įvertinti.',
  'label.you_can_send_residential_project_to_leader': 'Galite nusiųsti savo rezidavimo projektą DofE vadovui įvertinti.',
  'label.you_have_finished_now_send_to_approval': 'Jūsų veikla baigta. Galite ją pateikti Vertintojui patvirtinti. Galite pridėti pastabą žemiau.',
  'label.preparation_and_training': 'Pasiruošimas ir žygio planavimas',
  'label.you_will_be_redirected_to_the_payment': 'Būsite nukreipti į Payment Gateway, kur galėsite sumokėti kreditine arba debetine kortele.',
  'label.you_will_be_the_first_award_leader': 'Jūs esate pirmas DofE vadovas savo organizacijoje. Turite teisę pridėt daugiau DofE vadovų, dalyvių ir tvarkyti informaciją e-DofE platformoje.',
  'label.youll_receive_a_notification': 'Gausite pranešimą, kai DofE vadovas patvirtins Jūsų registraciją. Galite prisijungti prie ORB Next Generation <a>here</a>  (kol DofE vadovas patvirtins Jūsų registraciją, turėsite tik limituotą prieigą).',
  'label.your_parent_email': 'Tėvų/globėjų el. pašto adresas',
  'label.your_parent_first_name': 'Tėvų/globėjų vardas',
  'label.your_parent_last_name': 'Tėvų/globėjų pavardė',
  'label.your_report_approve_now_send_to_leader': 'Vertintojas patvirtino Jūsų ataskaitą. Galite ją pateikti DofE vadovui patvirtinti. Galite pridėti pastabą žemiau.',
  'label.there_are_loads_of_exciting_possibilities': 'Čia rasite daug galimybių. Pasirinkite tai, kas Jums teikia daugiausia pasitenkinimo.',
  'label.your_residential_project_has_been_setup': 'Jūsų rezidavimo projektas pateiktas ir nusiųstas DofE vadovui patvirtinti.',
  'label.your_report_has_been_sent_assessor': 'Ataskaita nusiųsta vertintojui įvertinti.',
  'label.your_report_has_been_sent_leader': 'Ataskaita nusiųsta DofE vadovui įvertinti.',
  'label.your_residential_project_is_complete': 'Rezidavimo projektas baigtas.',
  'label.to_work_on_the_online': 'Tam, kad galėtumėte naudotis e-DofE platforma, turite sukurti savo paskyrą.',
  'label.we_will_send_you_an_email': 'Išsiųsime Jums laišką su patvirtinimu, kad Jūsų registracija patvirtinta.',
  'label.if_you_have_any_problems_or_doubts': 'jei iškilo problemų ar turite klausimų, susisiekite su Apdovanojimus vykdančia organizacija.',
  'label.are_you_sure_you_want_to_leave': 'Ar tikrai norite baigti? Duomenys bus prarasti.',
  'label.no_logs_yet': 'Nėra įrašų. <br /> Pridėkite naują įrašą spausdami "Pridėti įrašą".',
  'label.menu': 'Meniu',
  'notifications.award_unit_has_been_created': 'Organizacija sukurta',
  'notifications.authorization_code_is_not_valid': 'Atpažinimo kodas negalioja',
  'notifications.email_has_been_confirmed': 'El. pašto adresas patvirtintas',
  'notifications.leader_has_been_created': 'DofE vadovas sukurtas',
  'notifications.participant_has_been_created': 'Dalyvis sukurtas',
  'notifications.email_with_instructions_has_been_sent': 'Instrukcijos išsiųstos el. paštu',
  'notifications.your_new_password_has_been_set': 'Naujas slaptažodis išsiųstas',
  'notifications.success': 'Sėkminga',
  'notifications.unknown_role': 'Nežinoma paskirtis',
  'notifications.waiting_for_approval': 'Laukiama patvirtinimo',
  'notifications.activity_cannot_be_created': 'Veikla negali būti sukurta, kol Jūsų registracija nėra patvirtinta',
  'notifications.new_activity_has_been_added': 'Nauja veikla pridėta',
  'notifications.new_log_has_been_added': 'Naujas įrašas pridėtas',
  'notifications.log_has_been_deleted': 'Įrašas ištrintas',
  'notifications.log_has_been_modified': 'Įrašas pakeistas',
  'notifications.adventurous_journey_cannot_be_created_until_approved': 'Žygis negali būti pradėtas, kol Jūsų registracija nėra patvirtinta.',
  'notifications.new_participant_event_has_been_added': 'Naujas dalyvis buo pridėtas',
  'notifications.participant_event_has_been_completed': 'Dalyvio veikla užbaigta',
  'notifications.training_and_practice_modified': 'Pasiruošimas ir žygio planavimas pakeisti',
  'notifications.completion_residential_project_completed': 'Rezidavimo projektas baigtas',
  'notifications.new_residential_project_has_been_added': 'Pridėtas naujas rezidavimo projektas',
  'notifications.residential_project_cannot_be_created_until_approved': 'Rezidavimo projektas negali būti pradėtas, kol Jūsų registracija nėra patvirtinta.',
  'notifications.already_assessed_sent': 'Prašymas patvirtinti išsiųstas DofE vadovui',
  'notifications.assessment_request_sent': 'Prašymas įvertinti išsiųstas',
  'notifications.leader_approval_sent': 'Prašymas patvirtinti išsiųstas DofE vadovui',
  'tabs.logs': 'Įrašai',
  'tabs.new': 'Nauja',
  'tabs.overview': 'Peržiūra',
  'tabs.report': 'Ataskaita',
  'button.add_activity': 'Pridėti veiklą',
  'button.add_log': 'Pridėti įrašą',
  'button.continue_here': 'Spauskite čia',
  'button.continue': 'Tęsti',
  'button.continue_to_award': 'Tęsti Apdovanojimą',
  'button.delete': 'Ištrinti',
  'button.edit': 'Redaguoti',
  'button.edit_log': 'Redaguoti įrašą',
  'button.finish': 'Baigti',
  'button.forgot_your_password': 'Pamiršote slaptažodį?',
  'button.i_already_have_assessment': 'Jau turiu įvertinimą',
  'button.leave_anyway': 'Palikti',
  'button.login': 'Prisijungti',
  'button.no': 'Ne',
  'button.register': 'Registruotis',
  'button.send': 'Siųsti',
  'button.send_for_approval': 'Siųsti patvirtinti',
  'button.setup': 'Nustatymai',
  'button.setup_residential': 'Nustatyti rezidavimo projektą',
  'button.stay': 'Pasilikti',
  'button.submit': 'Pateikti',
  'button.update': 'Atnaujinti',
  'button.yes': 'Taip',
  'errors.at_least_num_characters': 'Bent {lenght} simbolių ilgio',
  'errors.do_not_match': 'Neatitinka',
  'errors.include_at_least_one_number': 'Įtraukite bent vieną skaitmenį',
  'errors.include_both_lower_and_upper_case': 'Įtraukite didžiąją ir mažąją raides',
  'errors.invalid_phone_format': 'Neteisingas telefono numerio formatas',
  'errors.invalid_email_address': 'Neteisingas el. pašto adresas',
  'errors.required_field': 'Privalomas laukas',
  'errors.must_be_at_least': 'Bent {min} simbolių ilgio',
  'errors.must_be_no_more_than': 'Ne daugiau nei {max} simbolių ilgio',
  'errors.must_be_an_integer': 'Must be an integer',
  'errors.must_contain_at_least': 'Turi turėti bent vieną skaitmenį',
  'errors.must_include_at_least': 'Turi turėti bent vieną didžiąją ir mažąją raides',
  'errors.must_be_one_of': 'Turi būti vienas iš: {enums}',
  'errors.you_must_be_younger_than': 'Turite būti jaunesnis nei {years} metai ir {months} mėnesiai, kad galėtumėte dalyvauti Apdovanojimų programoje. Dėl to kreipkitės į Apdovanojimus vykdančios organizacijos personalą.',
  'errors.you_must_be_older_than': 'Turite būti vyresnis nei {years} metai ir {months} mėnesiai, kad galėtumėte dalyvauti Apdovanojimų programoje. Dėl to kreipkitės į Apdovanojimus vykdančios organizacijos personalą.',
  'errors.email_address_is_in_use_please_sign': 'Toks el. pašto adresas jau egzistuoja. Jei norite siekti kito Apdovanojimų lygio, prisijunkite prie savo paskyros.',
  'errors.email_address_is_in_use': 'Toks el. pašto adresas jau egzistuoja. ',
  'errors.sorry_we_already_have_this_email': "Atsiprašome, tačiau toks el. pašto adresas jau egzistuoja. Jei norite pradėti naują lygį, <a href='/'>prie savo paskyros </a> ir pasirinkite skiltį Pradėti naują lygį.",
  'wizard.authorising_contact': 'Įgalioto asmens kontaktai',
  'wizard.award_leader_contact': 'DofE vadovo kontaktas',
  'wizard.award_unit_details': 'Organizacijos duomenys',
  'wizard.contact_details': 'Kontaktai',
  'wizard.contacts': 'Kontaktai',
  'wizard.level': 'Apdovanojimo lygis',
  'wizard.level_selection': 'Apdovanojimo lygio pasirinkimas',
  'wizard.leader_details': 'DofE vadovo duomenys',
  'wizard.nominated_award_leader': 'Paskirtas DofE vadovas',
  'wizard.orb_account': 'e-DofE platformos paskyra',
  'wizard.parent_consent': 'Tėvų sutikimas',
  'wizard.participant_details': 'Dalyvio duomenys',
  'wizard.profile': 'Profilis',
  'wizard.payment': 'Mokėjimas',
  'wizard.select_award_unit': 'Pasirinkti organizaciją',
  'wizard.unit_details': 'Organizacijos duomenys',
  'wizard.welcome': 'Sveiki',
  'wizard.your_details': 'Jūsų duomenys',
  'awardUnit.do_you_want_to_create': 'Norite sukurti naują organizaciją?',
  'parent.you_can_download_the_consent_here': 'jei dar neturite tėvų sutikimo formos, ją galite parsisiųti čia. Duokite pasirašyti ją savo tėvams/globėjams ir grąžinkite DofE vadovui.',
  'footer.copyright': "&copy; Autoriaus teisės The Duke of Edinburgh's International Award {year}",
  'registration_participant.required_award_payment': 'Privaloma mokėjimas už programą',
  'registration_participant.pay_online_here': 'Mokėkite internetu ir gaukite pavedimo numerį čia.',
  'dashboard.activity_log_time': '{hours}val {minutes}min',
  'moduleTitle.award_completed': 'Apdovanojimas pabaigtas!',
  'notifications.award_approval_request_sent_to_leader': 'Prašymas patvirtinti Apdovanojimą nusiųstas DofE vadovui',
  'notifications.new_participant_event_has_been_completed': 'Naujas dalyvis užregistruotas',
  'notifications.preparation_and_training_approval_sent': 'Patvirtinimas mokymuisi ir žygio planavimui išsiųstas',
  'notifications.reparation_and_training_completed': 'Pasiruošimas ir žygio planavimas baigtas',
  'notifications.your_profile_photo_has_been_edited': 'Jūsų profilio nuotrauka buvo redaguota',
  'notifications.your_profile_has_been_edited': 'Jūsų profilis buvo redaguotas',
  'notifications.new_level_has_started': 'Naujas lygis pradėtas',
  'notifications.activity_has_been_edited': 'Veikla redaguota',
  'notifications.you_have_been_logged_out': 'Atsijungiama',
  'notifications.logging_out': 'Atsijungėte',
  'label.you_can_send_award_to_leader': 'Galite siųsti Apdovanojimo lygį DofE vadovui patvirtinti',
  'label.you_have_completed_all_sections_of_your_award': 'Pabaigėte visas Apdovanojimo lygio dalis. Galite jas pateikti DofE vadovui patvirtinti. Galite pridėti pastabą žemiau.',
  'label.you_have_now_completed_your_award': 'Jūs pabaigėte Apdovanojimo lygį {level}. Ar norite pradėti kitą lygį?',
  'label.congratulation_your_award_has_been_approved': 'Sveikiname. Jūsų Apdovanojimo lygis {level} patvirtintas. <br /> Jei norite, galite pradėti naują lygį.',
  'moduleTitle.settings': 'Parametrai',
  'moduleTitle.edit_activity': 'Redaguoti veiklą',
  'moduleTitle.select_your_major_activity': 'Pasirinkite pagrindinę veiklą',
  'label.settings': 'Parametrai',
  'label.major_activity_means_that_you_will': '"Pagrindinė veikla" reiškia, kad šiai veiklai reikia skirti daugiau laiko, nei kitoms veikloms. Siekiantiems Aukso ir Sidabro ženklelio tai yra papildomi šeši mėnesiai, siekiantiems Bronzos ženklelio - trys mėnesiai.',
  'label.notifications': 'Pranešimai',
  'label.my_award': 'Mano Apdovanojimas',
  'label.physical_recreation': 'Aktyvi veikla',
  'label.skill': 'Įgūdžiai',
  'label.service': 'Paslaugos',
  'label.my_parent_will_complete_and_sign_form': 'Mano tėvas/globėjas užpildys ir pasirašys sutikimo formą',
  'label.please_print_it_tak_it_to_your_parent': 'Atsispausdinkite formą ir paduokite savo tėvams/globėjams pasirašyti ir tuomet grąžinkite DofE vadovui.',
  'label.change_password': 'Pakeisti slaptažodį',
  'label.change_major_activity': 'Pakeisti pagrindinę veiklą',
  'title.change_password': 'Keisti slaptažodį',
  'label.old_again': 'Senas slaptažodis',
  'label.new_password': 'Naujas slaptažodis',
  'label.new_password_again': 'Pakartoti naują slaptažodį',
  'errors.passwords_dont_match': 'Slaptažodžiai nesutampa',
  'errors.more_than': 'Daugiau nei {limit}',
  'button.parent_guardian_consent_pdf': 'Tėvų/globėjų sutikimas.pdf',
  'button.send_award_for_approval': 'Siųsti Apdovanojimo lygį patvirtinti',
  'button.send_report': 'Siųsti patvirtinti',
  'button.terms_and_conditions': 'Tarptautiniai terminai ir sąlygos',
  'button.privacy_policy': 'Privatumo politika',
  'button.save': 'Išsaugoti',
  'button.start_new_level': 'Pradėti naują lygį',
  'button.change_password': 'Keisti slaptažodį',
  'button.edit_activity': 'Redaguoti veiklą',
  'moduleTitle.file_upload': 'Įkeltas failas',
  'label.add_file': 'Pridėti failą',
  'label.description': 'Aprašymas',
  'label.waiting_for_office_sign_off': 'Laukiama Nacionalinio Apdovanojimų centro patvirtinimo',
  'notifications.file_has_been_uploaded': 'Failas įkeltas',
  'tabs.files': 'Failai',
  'button.upload': 'Įkelti',
  'button.upload_file': 'Įkelti failą',
  'button.add_file': 'Pridėti failą',
  'button.this_activity_has_no_assessor': 'Veikla neturi Vertintojo. Turite pasirinkti vertintoją prieš siunčiant veiklą patvirtinti.',
  'label.i_want_to_register_my_award': 'Noriu užregistruoti Apdovanojimus vykdančią organizaciją kaip Nepriklausomą Apdovanojimų centrą',
  'label.select_sub_operating_authority': 'Pasirinkti vykdančią organizaciją',
  'label.your_must_first_setup_some_activity': 'Pirmiausia turite pasirinkti veiklą',
  'label.you_cant_change_your_major_activity': 'Negalite keisti pagrindinės veiklos. Jūsų pagrindinė veikla jau pabaigta',
  'label.s_specific': 'Konkretus: Jūsų tikslas neturi būti per platus. </b> Vietoje to, kad rašytumėte: "Noriu geriau groti smuiku", galite sakyti "Noriu gerai išmokti groti F-dur gamą". ',
  'label.m_measurable': '<b>M- Išmatuojamas: Jūs turite gebėti pasakyti, kada pasiekėte savo tikslą. </b> Vietoje to, kad apibrėžtumėte savo tikslą kaip "Aš noriu padėti bendruomenei", turėtumėte sakyti "Noriu padėti žmonėms, kurie lankosi nemokamose valgyklose, savanoriaudamas ten kartą per savaitę". Tokį tikslą galima išmatuoti.',
  'label.a_achievable': '<b>A - Įgyvendinamas: Jūsų tikslas turi būti toks, kurį galima pasiekti per ženkleliui pasiekti skirtą laiką.</b> Vietoje to, kad sakytumėte "Noriu panaikinti skurdą", turėtumėte nusistatyti praktiškesnį tikslą, pavyzdžiui, "Norėčiau pritraukti lėšų ir paskirti jas trečiojo pasaulio šalims tam, kad būtų sumažintas skurdas"',
  'label.r_realistic': '<b>R - Prasmingas: Tai yra beveik tas pats, kas "Įgyvendinamas".</b> Ar Jums yra realistiška pasiekti šį tikslą per atitinkamą laiko tarpą?',
  'label.t_timely': '<b> - Apribotas laike: Jūsų tikslas turi turėti aiškų tikslo įgyvendinimo laiką.</b> Jūsų tikslas galėtų būti "Norėčiau išmokti groti F-dur gamą smuiku per tris mėnesius".',
  'label.you_can_upload_here_any_files': 'Čia galite įkelti failus (10 mb ar mažesnius), kuriais norite pasidalinti su savo DofE vadovu.',
  'moduleTitle.login_change': 'Prisijungimas pakeistas',
  'notifications.adventurous_journey_modified': 'Žygis pakeistas',
  'tabs.sections': 'Dalys',
  'label.change_email': 'Pakeisti el. pašto adresą',
  'title.change_email': 'Pakeisti el. pašto adresą',
  'label.new_email': 'Naujas el. pašto adresas',
  'label.new_email_again': 'Pakartoti el. pašto adresą',
  'errors.emails_dont_match': 'El. pašto adresai neatitinka',
  'button.change_email': 'Pakeisti el. pašto adresą',
  'notifications.email_with_instructions_has_been_sent_to_your_inbox': 'Instrukcijos nusiųstos Jūsų el. paštu',
  'global.dofe_name': 'The Duke of Edinburgh’s Award',
  'global.or': 'arba',
  'route.landing_page': 'Ieškos juosta',
  'route.dashboard': 'Pagrindinis puslapis',
  'moduleTitle.notifications': 'Pranešimai',
  'moduleTitle.no_notifications': 'Nėra pranešimų',
  'moduleTitle.new_notifications': 'Nauji pranešimai',
  'moduleTitle.older_notifications': 'Senesni pranešimai',
  'moduleTitle.user_guide': 'Vartotojo vadovas',
  'label.user_guide': 'Vartotojo vadovas',
  'notifications.your_password_has_been_changed': 'Slaptažodis pakeistas',
  'label.country': 'Šalis',
  'label.on_your_smartphone': 'Jūsų mobiliajame telefone',
  'label.on_the_web': 'Internetiniame puslapyje',
  'label.orb_online': 'e-DofE platforma',
  'label.language': 'Kalba',
  'moduleTitle.participant_login': 'Dalyvio prisijungimas',
  'label.for_ios': 'skirta iOS',
  'label.for_android': 'skirta Android',
  'button.login_as_award_staff': 'Prisijungti kaip Apdovanojimų programos personalui.',
  'errors.leader_doesnt_exist': 'Vadovo nėra',
  'global.loading': 'Kraunama',
  'moduleTitle.award_staff_login': 'Apdovanojimų centro personalo prisijungimas',
  'formTitle.residential_project_details': 'rezidavimo projekto detalės',
  'label.you_can_also_download_participant': 'Galite parsisiųsti naują <strong> Dalyvio programėlę </strong> ir prisijungti prie e-DofE platformos bet kuriuo metu.',
  'label.you_can_also_download_leader': 'Galite parsisiųsti naują <strong> Vadovo programėlę </strong> ir prisijungti prie e-DofE platformos bet kuriuo metu.',
  'notifications.this_role_is_not': 'Laikinai neveikia',
  'notifications.residential_project_has_been_updated': 'Rezidavimo projektas atnaujintas',
  'tabs.participant': 'Dalyvis',
  'tabs.award_staff': 'Vadovas',
  'moduleTitle.edit_residential_project': 'Redaguoti rezidavimo projektą',
  'button.residential_project': 'Redaguoti rezidavimo projektą',
  'notifications.your_login_email_has_been_changed': 'Jūsų prisijungimo el. paštas pakeistas',
  'meta.dofe_name': 'The Duke of Edinburgh’s Award',
  'notifications.unknown_role_leader': 'Nežinoma rolė - naudokite Apdovanojimų personalo prisijungimus',
  'notifications.unknown_role_participant': 'Nežinoma rolė - naudokite dalyvio prisijungimus',
  'label.user_guide_web_participant': 'Naudotojo elektroninis vadovas - dalyvis',
  'label.user_guide_app_participant': 'Naudotojo elektroninis vadovas - dalyvis',
  'label.note_for_supervisor': 'Pranešimas vadovui',
  'label.before_submitting_your_aj': 'Prieš siunčiant duomenis apie žygį DofE vadovui, turite gauti patvirtinimą iš savo {role}. Jei norite, žemiau galite pridėt pastabą.',
  'button.back_to_home': 'Grįžti',
  'moduleTitle.assessor_approval': '{role} patvirtinimas',
  'label.this_aj_has_no_assessor': 'Šis žygis neturi {role}. Turite atnaujinti duomenis prieš siųsdami patvirtinti.',
  'route.not_found': 'Nerasta',
  'notifications.are_you_sure': 'Tikrai?',
  'button.cancel': 'Atšaukti',
  'label.add_document': 'Pridėti dokumentą',
  'errors.there_are_currently_no_details_for_your': 'Šiuo metu nėra dokumentų, skirtų {role}. Prašome užpildyti trūkstamus duomenis prieš siunčiant veiklą įvertinti',
  'moduleTitle.missing_data': 'Trūksta duomenų',
  'label.to_send_assessment_request': 'Jei norite nusiųsti prašymą įvertinti veiklą elektroniniu būdu, įrašykite {role} el. pašto adresą',
  'label.pending_changes': 'Laukiama pakeitimų',
  'label.some_fields_require': 'Kai kurie laukeliai turi būti peržiūrėti',
  'roles.assessor': 'Vertintojas',
  'roles.supervisor': 'Prižiūrėtojas',
  'pageTitle.register_participant': 'Užregistruoti dalyvį',
  'moduleTitle.revise_message': 'Peržiūrėti žinutę',
  'moduleTitle.payment_for_level': 'Apmokėjimas už {awardLevel}',
  'moduleTitle.payment': 'Dalyvio registracijos mokestis',
  'moduleTitle.we_have_sent_you_payment_link': 'Išsiuntėme Jums laišką el. paštu su nuoroda į Elektroninius valdžios vartus.',
  'label.required_award_payment': 'Privalomas apmokėjimas už programą',
  'label.payment_fees': 'mokestis',
  'label.payment_method': 'Apmokėjimo būdas',
  'label.you_will_type_trans_id': 'Įveskite pavedimo identifikavimo numerį.',
  'label.any_level_previously': 'bet kuris prieš tai baigtas programos lygis',
  'label.registering_for_level': 'Registracija į Apdovanojimo lygį',
  'notification.payment_link_expired': 'Apmokėjimo už programą nuorodos galiojimo laikas baigėsi',
  'button.pay': 'Mokėti',
  'label.registration_updated': 'Jūsų registracija atnaujinta, galite uždaryti šį puslapį.',
  'label.award_leader_receive_payment': 'Jūsų DofE vadovas gaus informaciją apie apmokėjimą.',
  'errors.end_date_after': 'Pabaigos data turi būti po pradžios datos',
  'button.back': 'Grįžti',
  'button.edit_info': 'Redaguoti informaciją',
  'moduleTitle.level_detail': 'Apdovanojimo lygio duomenys',
  'label.payment_methods': 'Apmokėjimo būdai',
  'label.address': 'Adresas',
  'note.review_filled_participant': 'Prašome peržiūrėti dalyvio užpildytą informaciją. Neteisingą informaciją galite redaguoti.',
  'moduleTitle.payment_successful': 'Dalyvio registracijos mokestis gautas',
  'button.proceed_to_login': 'Tęskite prisijungimą',
  'label.add_additional_activity': 'Pridėkite papildomą veiklą',
  'moduleTitle.welcome_to_orb': 'Sveikiname prisijungus prie e-DofE platformos',
  'empty_dashboard.not_approved': 'Ši platforma padės Jums stebėti savo progresą, siekiant apdovanojimo lygio. Tačiau kol kas DofE vadovas nepatvirtino Jūsų profilio. Prieš pradedant pildyti veiklas, turite sulaukti patvirtinimo.',
  'empty_dashboard.approved_1': 'Ši platforma padės Jums stebėti savo progresą, siekiant apdovanojimo lygio. ',
  'empty_dashboard.approved_2': 'Pirmiausia turite nustatyti savo veiklą. Tam turite paspausti pirmą mygtuką kairėje. Jei Jums reikia pagalbos kuriant veiklą, prašykite DofE vadovo pagalbos.',
  'label.discuss_activity_leader': 'Jei renkatės daugiau nei vieną veiklą, aptarkite tai su savo DofE vadovu.',
  'label.cannot_add_activity': 'Šioje dalyje galite įrašyti daugiausia 3 veiklas. Aptarkite tai su savo DofE vadovu.',
  'button.ok': 'Gerai',
  'label.payment_was_canceled': 'vartotojas atšaukė apmokėjimą.',
  'label.problem_with_payment': 'Įvyko klaida vykdant Jūsų apmokėjimą. Prašome susisiekti su Nacionaliniu Apdovanojimų centru (NAC).',
  'pageTitle.register_leader': 'Užregistruoti vadovą',
  'pageTitle.registration_complete': 'registracija baigta',
  'label.payment_link_expired_or_paid': 'Jūs jau sumokėjote registracijos mokestį arba apmokėjimui skirta nuoroda baigė galioti.',
  'label.contact_nao_assistance': 'Jei reikia pagalbos, susisiekite su NAC.',
  'label.send_required_amount_to_your_award_leader': 'Nusiųskite reikalingą sumą savo DofE vadovui arba koordinatoriui.',
  'label.fee_can_be_paid': 'Mokestis gali būti sumokėtas naudojantis VISA, MasterCard arba Credit Debit kortelėmis.',
  'notifications.login_failed_right_tab': 'Prisijungimas nesėkmingas. Įsitikinkite, kad pasirinkote tinkamą skiltį (Dalyvis/Vadovas).',
  'label.i_have_read_privacy_policy': 'Perskaičiau privatumo politiką ir sutinku..',
  'errors.invalid_date_format': 'Netinkamas datos formatas',
  'label.no_privacy_policy': 'Galite tęsti paspausdami šį mygtuką',
  'label.status': 'Statusas',
  'moduleTitle.attached_with_observation': 'Prisegta su pastebėjimais',
  'moduleTitle.revise_message_rp': 'Jūsų DofE vadovas peržiūrėjo rezidavimo projektą',
  'file.activity_section_summary': '{section} - dalis - santrauka',
  'label.download_section_summary': 'Parsisiųsti dalies santrauką',
  'label.award_summary': 'Apdovanojimo lygio santrauka',
  'btn.download_summary_for_assessor': 'Parsiųsti santrauką vertintojui',
  'label.first_activity_started': 'Pirma veikla pradėta',
  'label.hours_completed_required': 'Baigtos/privalomos valandos',
  'label.weeks_completed_required': 'Baigtos/privalomos savaitės',
  back_to_home: 'Grįžti į pradinį puslapį',
  'label.activity_rejected_click': 'DofE vadovas atmetė Jūsų veiklą. Spauskite',
  'button.more_information': 'daugiau informacijos',
  'label.attached_file': 'Pridėtas failas',
  'moduleTitle.journey_details': 'Žygio detalės',
  'tabs.activity': 'Veikla',
  'label.confirm_email': 'Patvirtinti el. pašto adresą',
  'label.aj_rejected_click': 'DofE vadovas atmetė žygį. Spauskite',
  'label.verifying_payment': 'Tvirtinamas mokėjimas',
  'button.finish_and_pay': 'Baigti ir sumokėti',
  'label.payment_not_successful_text': 'Jūs nesumokėjote už apdovanojimo lygį, apmokėjimą būtina padaryti dabar',
  'label.payment_not_completed': 'Mokėjimas nebaigtas',
  'button.pay_now': 'Mokėti dabar',
  'label.registration_pending_parental_consent': 'Jūsų registracijai reikalingas tėvų/globėjų sutikimas',
  'button.edit_observation': 'Peržiūrėti stebėjimus',
  'moduleTitle.qualifying': 'Kvalifikacinis',
  'moduleTitle.practice': 'Praktika',
  'label.first_log_entry': 'Pirmo prisijungimo įrašas',
  'label.first_log_entry_date': 'Pirmo įrašo data',
  'label.last_log_entry': 'Paskutinio prisijungimo įrašas',
  'label.last_log_entry_date': 'Paskutinio prisijungimo įrašo data',
  'label.you_can_send_journey_report_for_approval': 'Siųsti {journey} žygio ataskaitą patvirtinti.',
  'button.edit_and_resend_report': 'Redaguoti ir persiųsti ataskaitą',
  'label.your_journey_is_complete': 'Jūsų {journeyType} žygis baigtas.',
  'button.add_additional_journey': 'Pridėti papildomą žygį',
  'moduleTitle.edit_journey': 'Redaguoti žygį',
  'notifications.assessment_sent': 'Vertinimas išsiųstas',
  'notifications.file_is_too_big': 'Failas negali būti įkeltas. Failo dydis negali viršyti 10 mb.',
  'notifications.authorization_code_has_expired': 'Patvirtinimo kodas nebegalioja saugumo sumetimais, prašykite naujo kodo',
  'route.confirm_email': 'Patvirtinti el. pašto adresą',
  'label.assessor_needs_account': 'Norint dirbti su e-DofE platforma, Jums reikia asmeninės paskyros. <br/> Prašome įvesti savo duomenis čia',
  'label.company_name': 'Organizacijos pavadinimas',
  'label.secondary_email_again': 'Patvirtinti antrą el. pašto adresą',
  'label.how_many_years': 'Kiek metų/mėnesių?',
  'label.no_company_leave_empty': 'Jei nedirbate jokioje organizacijoje, šį laukelį palikite tuščią',
  'label.secondary_phone_number': 'Antras telefono numeris',
  'label.secondary_phone_type': 'Antro telefono tipas',
  'label.wwc_application_number': 'Vaiko apsaugos numeris',
  'label.wwc_expiration_date': 'Vaiko apsaugos pabaigos data',
  'label.you_are_now_registering_as_assessor': 'Jūs registruojatės kaip vertintojas',
  'label.you_have_finished_aj_now_send_to_approval': 'Jūsų žygis pabaigtas. Galite jį pateikti vertintojui įvertinti. Žemiau galite parašyti asmeninę žinutę.',
  'label.your_experience': 'Jūsų patirtis',
  'label.your_qualification': 'Jūsų kvalifikacija',
  'notifications.waiting_for_assessor_approval': 'Laukiama vertintojo patvirtinimo',
  'button.resend_assessment_request': 'Persiųsti prašymą įvertinti',
  'errors.emails_must_be_different': 'Antras el. pašto adresas turi skirtis nuo pirmojo',
  'moduleTitle.company_details': 'Organizacijos duomenys',
  'notifications.already_resent_assessment_request': 'Jūs jau išsiuntėte įvertinimo prašymą',
  'route.assessor_dashboard': 'Vertintojo valdymo skydelis',
  'pageTitle.register_assessor': 'Užregistruoti vertintoją',
  'wizard.assessor_details': 'Vertintojo duomenys',
  'wizard.assessor_experience': 'Vertintojo patirtis',
  'wizard.personal_details': 'Ameniniai duomenys',
  'button.sign_off': 'Atsijungti ',
  'button.sign_off_dashed': 'Atsijungti ',
  'moduleTitle.sign_off': 'Atsijungti ',
  'label.certify_participant_met_reqs': 'Kaip vertintojas patvirtinu, kad dalyvio veikla atitinka visus reikalavimus',
  'label.assessor_report': 'Vertintojo ataskaita',
  'label.content_update': 'palaukite. Atnaujinamas turinys...',
  'label.comment_on_participant_improvement': 'Pakomentuokite dalyvio pažangą/veiklos atlikimą',
  'note.edit_participant_review': 'Norėdami koreguoti informaciją, paspauskite mygtuką "koreguoti"',
  'errors.min_age': 'Minimalus amžius yra {age}',
  'notifications.assessor_link_expired': 'Vertintojo registracijos nuorodos galiojimo laikas baigėsi',
  'label.secondary_email': 'Antras el. pašto adresas',
  'moduleTitle.review_participant_info': 'Peržiūrėti dalyvio informaciją',
  'label.loading_payment_gateway': 'Kraunami elektroniniai valdžios vartai',
  'label.consent_given_login_as_child': 'Sutikimas duotas. Prašome užregistruoti vaiką',
  'notifications.only_one_qualification_journey_per_award': 'Gali būti užregistruotas tik kvalifikacinis žygis.',
  'label.registration_fees_participant': 'Registracijos mokestis - {name} (#{id})',
  'moduleTitle.leader_details': 'Vadovo duomenys',
  'label.leader_name': 'Vadovo vardas',
  'label.leader_phone': 'Vadovo telefono numeris',
  'label.leader_email': 'Vadovo el. pašto adresas',
  'moduleTitle.au_details': 'Apdovanojimus vykdančios organizacijos duomenys',
  'label.au_name': 'Apdovanojimus vykdančios organizacijos pavadinimas',
  'label.assessor_guidelines': 'Gairės',
  'label.assessor_cond_req': 'Pagrindinės sąlygos ir reikalavimai',
  'label.assessor_ref_handbook': 'Nuoroda į naudotojo vadovą',
  'label.assessor_ref_online_modules': 'Nuoroda į mokymosi modulius',
  'label.participant_has_no_aj_report': 'Dalyvis dar neįkėle ataskaitos',
  'moduleTitle.participant_details': 'Dalyvio duomenys',
  'label.participants_has_no_logs': 'Dalyvis dar neturi įrašų.',
  'label.location_type': 'Vieta',
  'label.activity_ready_for_signoff': 'Veikla paruošta patvirtinti.',
  'label.activities': 'Veiklos',
  'label.choose_how_you_want_to_login': 'Pasirinkite, kaip norite prisijungti',
  'roles.leader': 'Vadovas',
  'roles.award_verifier': 'Award Verifier',
  'roles.coordinator': 'Koordinatorius',
  'roles.aj_assessor': 'Žygio vertintojas',
  'roles.aj_supervisor': 'Žygio vertintojas',
  'roles.instructor': 'Instruktorius',
  'roles.nao_staff': 'NAC personalas',
  'roles.super_user': 'Aukštesnis vartotojas',
  'roles.user': 'Vartotojas',
  'roles.viewer': 'Peržiūrėtojas',
  'roles.authorizing_contact': 'Patvirtinantis kontaktas',
  'roles.if_staff_superuser': 'Tarptautinio fondo personalo aukštesnis vartotojas',
  'roles.if_staff_statistical_user': 'Tarptautinio fondo statistinis vartotojas',
  'roles.if_staff_viewer': 'Tarptautinio fondo peržiūrėtojas',
  'roles.aj_instructor': 'Žygio vertintojas',
  'label.if_you_have_questions_au': 'Jei turite klausimų dėl registracijos, susisiekite su savo apdovanojimu vykdančia organizacija.',
  'label.we_will_send_you_an_email_leader': 'Jūs gausite laišką, kai Jūsų registracija bus patvirtinta',
  'moduleTitle.rejecting_assessor_invitation': 'Kvietimas tapti vertintoju atmestas',
  'notifications.assessor_invitation_rejected': 'Kvietimas tapti vertintoju atmestas',
  'moduleTitle.participants_list_is_empty': 'Dalyvių sąrašas tuščias',
  'label.note_from_participant': 'Žinutė nuo dalyvio',
  'label.you_can_send_aj_to_leader': 'Galite siųsti žygį DofE vadovui patvirtinti.',
  'button.save_report': 'Išsaugoti ataskaitą',
  'label.this_activity_has_no_assessor': 'Ši veikla neturi vertintojo. Jūs turite įvesti vertintojo duomenis prieš siunčiant patvirtinti.',
  'label.activity_rejected_click_by_assessor': 'Vertintojas atmetė Jūsų veiklą. Paspauskite',
  'button.reject': 'Atmesti',
  'button.reject_invitation': 'Atmesti kvietimą',
  'label.reason': 'Priežastis',
  'label.accept_invitation_and_continue': 'Priimti kvietimą ir tęsti',
  'pageTitle.registration_reject': 'Registracijos atmetimas',
  'errors.you_must_be_older_than_register_for_leader': 'Turite būti vyresnis nei {years} metai ir {months} mėnesiai, kad galėtumėte registruotis kaip DofE vadovas.',
  'label.your_report_approve_now_send_to_leader_without_note': 'Jūsų ataskaita patvirtinta. galite ją nusiųsti DofE vadovui patvirtinti.',
  'button.stop_assessing_this_activity': 'NEBEVERTINKITE ŠIOS VEIKLOS',
  'button.confirm': 'Patvirtinti',
  'moduleTitle.are_you_sure': 'Tikrai?',
  'label.content_restore': 'Turinio atkūrimas',
  'button.stop_editing': 'Neberedaguoti',
  'notifications.activity_has_been_rejected': 'Veikla atmesta',
  'notifications.aj_has_been_rejected': 'Žygis atmestas',
  'notifications.rp_has_been_rejected': 'Rezidavimo projektas atmestas',
  'moduleTitle.additional_files': 'Papildomi failai',
  'moduleTitle.no_additional_files': 'Papildomi failai',
  'moduleTitle.stop_assessing_section': 'Nebevertinkite šios dalies',
  'label.show_security_and_refund_policy': 'Parodyti apsaugos ir pinigų grąžinimo politiką',
  'moduleTitle.security_and_refund_policy': 'Apsaugos ir pinigų grąžinimo politika',
  'label.fees_payment': 'Mokesčiai',
  'label.redund_policy': 'Grąžinimo politika',
  'label.security_policy': 'Saugumo politika',
  'label.leave_blank': 'Palikti tuščią',
  'label.frequently_asked_questions': 'Dažniausiai užduodami klausimai (DUK)',
  'label.language_selection_is_disabled_for_iac': 'Kalbos pasirinkimas išjungtas Neprilausomam Apdovanojimų centrui',
  'errors.min_nights_required': 'Reikalaujamas minimalus {nights} naktų skaičius',
  'label.completion_date': 'Pabaigos data',
  'label.you_are_offline': 'Jūs esate neprisijungęs. Pakeitimai gali būti neišsaugoti.',
  'errors.start_date_after_award_start': 'Pradžios data negali būti prieš Apdovanojimo lygio sukūrimo datą.',
  'label.participants': 'Dalyviai',
  'label.marketing_from_iaf': 'Pažymėkite, kad sutinkate gauti reklamines prekes iš tarptautinio Apdovanojimų fondo.',
  'label.marketing_from_oa': 'Pažymėkite, kad sutinkate gauti reklamines prekes iš tarptautinio Apdovanojimų fondo.',
  'label.marketing_from_nao': 'Pažymėkite, kad sutinkate gauti reklamines prekes iš NAC',
  'label.select_iac': 'pasirinkite nepriklausomą Apdovanojimų centrą',
  'label.you_will_be_redirected_to_the_paypal_payment': '',
  'notifications.report_has_been_sent': '',
  'label.processing_paypal_payment': '',
  'label.loading_paypal_gateway': '',
  'label.payment_failed': '',
  'label.payment_has_been_cancelled': '',
  'roles.naa_oa_staff': '',
  'label.download_report_and_upload_signed_version': '',
  'button.download_summary_for_assessor': '',
  'label.pay_online_mastercard': '',
  'label.pay_online_paypal': '',
  'notifications.authorization_code_is_missing': '',
  'errors.unknown_payment_error': '',
  'errors.already_in_use_by_auth_contact': '',
  'roles.if_staff_stat_user': '',
  'moduleTitle.you_have_been_logged_out_due_to_inactivity': '',
  'announcement.survey_description.do_think_people_are_lazy': '',
  'announcement.survey_title.join_our_global_survey': '',
  'announcement.survey_button.if_below_25': '',
  'announcement.survey_button.if_over_25': '',
  'moduleTitle.privacy_and_cookie_policy': '',
  'label.we_have_made_some_important_changes': '',
  'button.i_agree': '',
  'button.see_more_details': '',
  'label.the_cookie_settings_on_this': ''
}
